import React, { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import CloudformationOutputs from '../CloudformationOutputs.json'
import YellowAlert from '../ui-elements/YellowAlert'
import AlertsForCheckPeriod from './AlertsForCheckPeriod'
import NotesForCheckPeriod from './NotesForCheckPeriod'


function ExternalUserComplete() {

    const { tableData, t, externalUserState, handleLogout, currentOrganisation } = useContext(GlobalContext)
    const thisChecklistId = externalUserState && externalUserState.checklistId ? externalUserState.checklistId : null
    const thisChecklist = thisChecklistId && tableData && tableData.Checklists ? tableData.Checklists[thisChecklistId] : null
    const checklistName = thisChecklist ? thisChecklist.ChecklistName : ''
    const checklistPeriodId = externalUserState && externalUserState.checklistPeriodId ? externalUserState.checklistPeriodId : null
    const thisCheckPeriod = checklistPeriodId && tableData && tableData.ChecklistPeriods ? tableData.ChecklistPeriods[checklistPeriodId] : null
    const externalVisitorSettings = thisChecklist && thisChecklist.externalVisitorSettings
    const companyLogoUrl = externalVisitorSettings && externalVisitorSettings.companyLogo ? `https://${CloudformationOutputs.ImageBucketName}.s3.eu-west-1.amazonaws.com/${currentOrganisation}/${externalVisitorSettings.companyLogo}` : null
    const checkPeriodAlerts = thisCheckPeriod ? thisCheckPeriod.alertsForCheckPeriod : null
    const checkPeriodNotes = thisCheckPeriod ? thisCheckPeriod.notesForCheckPeriod : null
 


    if (!thisChecklist || !checklistPeriodId) {
        return <RedAlert>{t('Dashboard.ExternalUserDashboard.checklistOrPeriodNotFound')}</RedAlert>
    }

    return <Card fullwidth={true}>
        <div className={`w-full flex flex-col gap-6 items-center justify-center`}>
            <div className={`w-full flex flex-col gap-2 items-center justify-center`}>


                {(!externalVisitorSettings || !externalVisitorSettings.welcomeHeading) && <>
                    <p className={`text-6xl text-center`}>
                        🏆
                    </p>
                    <p className={`text-center`}>
                        {t('Dashboard.ExternalUserDashboard.checklistComplete')}
                    </p>

                    <h2 className={`font-righteous text-brandblue text-2xl text-center`}>
                        {checklistName}
                    </h2>
                </>}

                {companyLogoUrl &&
                    <img src={companyLogoUrl} alt="Company Logo" className="max-w-64 max-h-64 pb-4" />}

              {externalVisitorSettings && externalVisitorSettings.completedHeading && 
                <h2 className={`font-righteous text-brandblue text-2xl text-center`}>{externalVisitorSettings.completedHeading}</h2>}

                {externalVisitorSettings && externalVisitorSettings.completedText && 
                <p className={``}>{externalVisitorSettings.completedText}</p>}



                {checkPeriodAlerts && checkPeriodAlerts.length > 0 && <AlertsForCheckPeriod thisCheckPeriod={thisCheckPeriod} />}
                {checkPeriodNotes && checkPeriodNotes.length > 0 && <NotesForCheckPeriod thisCheckPeriod={thisCheckPeriod} />}

            </div>



            <div className={`w-full flex flex-row gap-2`}>
                {externalVisitorSettings && externalVisitorSettings.completedUrl && externalVisitorSettings.completedButtonText ? 
                <Button
                    onClick={ () => {
                        handleLogout()
                        window.open(externalVisitorSettings.completedUrl, '_blank')
                    }}
                    text={externalVisitorSettings.completedButtonText}
                    variant='primary'
                    size={`big`}
                    fullwidth={true}
                /> :
                
                <Button
                    onClick={handleLogout}
                    text={t('Dashboard.ExternalUserDashboard.logout')}
                    variant='primary'
                    size={`big`}
                    fullwidth={true}
                />
                }
            </div>
        </div>
    </Card>
}

export default ExternalUserComplete
